export default __webpack_public_path__ + "app/assets/images/common/img-noproject-4495da8c2476353e01563d8e11829cd7.png";